import React from 'react';
import styled from 'styled-components';
import { Text } from '@catalogo/theme-text';
import { Wrapper } from '../styles';

const Flexbox = styled.div`
  display: flex;
`;

const Cell = styled.div`
  align-self: center;
`;

const LoadingUI = styled.div`
  margin-right: 10px;
  @keyframes rotate {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }
  align-items: center;
  &:after {
    border-width: 4px;
    border: 2px solid ${({ theme }) => theme.primaryColor};
    animation: rotate 500ms infinite linear;
    border-radius: 100%;
    border-right-color: transparent;
    border-top-color: transparent;
    content: '';
    display: block;
    height: 48px;
    width: 48px;
  }
`;

export const Loading = ({ text }) => (
  <Wrapper>
    <Flexbox>
      <Cell>
        <LoadingUI />
      </Cell>
      <Cell alignSelfCenter>
        <Text>{text}</Text>
      </Cell>
    </Flexbox>
  </Wrapper>
);

Loading.defaultProps = { text: 'Calculando frete e prazo' };
